import { useMemo, useEffect, useState, useCallback } from 'react'
import debounce from 'lodash-es/debounce'

export const useDebounce = <T extends (...args: any[]) => any>(cb: T, ms = 0, cancelOnUnmount = true) => {
  const [isLoading, setIsLoading] = useState(false)

  const debounced = useMemo(() => {
    return debounce(async (...args) => {
      await cb(...args)
      setIsLoading(false)
    }, ms)
  }, [cb, ms])

  const returnCb = useCallback(
    (...args: any[]) => {
      setIsLoading(true)
      void debounced(...args)
    },
    [debounced]
  )

  const cancel = useCallback(() => {
    debounced.cancel()
    setIsLoading(false)
  }, [debounced])

  const flush = useCallback(() => {
    void debounced.flush()
  }, [debounced])

  useEffect(() => {
    return () => {
      if (cancelOnUnmount) {
        cancel()
      }
    }
  }, [cancel, cancelOnUnmount])

  return [returnCb, isLoading, cancel, flush] as const
}
